import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import i18n from 'i18next';
const Header = ({toggle,setToggle}) => {

  const { t } = useTranslation();
  const currentLanguage = i18n.language; // Get the current language

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    
        
   
   
  };

  const logoSrc = currentLanguage === 'en' ? '/images/en-logo.svg' : '/images/logo.svg';
  return (
    <div className='w-full md:w-28 md:h-svh bg-white fixed md:sticky shadow-sm !left-0 md:right-0 top-0 z-50 py-6 md:py-0 px-[7.142%] md:px-0   flex flex-row md:flex-col justify-between border-l overflow-hidden'>


        <Link to={'/'} className='block md:hidden'><img                    src={logoSrc}                 alt={t('footer.logoAlt')} className=' w-48'/></Link>



        <div onClick={()=>setToggle(true)} className='md:w-full  md:mt-20  flex justify-center items-center cursor-pointer '>


          <div className='block h-7 w-10  relative group'>
            <div className='h-px   w-10 bg-black absolute top-0   transition-all duration-300'></div>
            <div className='h-px   w-7 group-hover:w-10 bg-black absolute top-3.5  transition-all duration-300'></div>
            <div className='h-px   w-10 bg-black absolute bottom-0 transition-all duration-300'></div>
          </div>


          {/* <div className=" block md:hidden w-6 h-10 relative group">
          <div className='w-px group-hover:w-0.5 h-10  bg-black absolute bottom-0 left-0 transition-all duration-300'></div>
          <div className='w-px group-hover:w-0.5 h-7  group-hover:h-10 bg-black absolute bottom-0 left-3 transition-all duration-300'></div>
          <div className='w-px group-hover:w-0.5 h-10  bg-black absolute bottom-0 left-6 transition-all duration-300'></div>
          </div> */}

        </div>







        <div className='w-full hidden md:flex flex-col justify-between items-center mb-10'>
        
          <a href='https://arlametal.com/' target='_blank'><img src='/images/arla.svg' className='w-full pl-4  pr-2 mb-10 hidden md:block customHover'/></a>
         <Link to={'/pdfs'}><img src='/images/catalog.svg' className=' w-6 mb-10 hover:scale-105 duration-300' /></Link> 

          {currentLanguage === 'tr'&&
          <div onClick={() => changeLanguage('en')} className='border-b mb-10 text-16 cursor-pointer hover:scale-105 duration-300'>
              EN
          </div>

}
{currentLanguage === 'en'&&
          <div onClick={() => changeLanguage('tr')} className='border-b mb-10 text-16 cursor-pointer hover:scale-105 duration-300'>
              TR
          </div>
}
          <div className='space-y-5 flex flex-col items-center justify-center'>
              <a href='https://www.instagram.com/gokdeleniskelekalip/' target='_blank'><img src='/images/header/i.svg' className=' customHover cursor-pointer w-4 md:w-7'/></a>
              <a href='https://www.facebook.com/gokdeleniskelekalip' target='_blank'><img src='/images/header/f.svg' className='customHover cursor-pointer  w-4 md:w-7'/></a>
              <a href='https://www.linkedin.com/company/10594998/admin/dashboard/' target='_blank'><img src='/images/header/li.svg' className='customHover cursor-pointer  w-4 md:w-7'/></a>
              <a href='https://www.youtube.com/@gokdeleniskelekalp3165' target='_blank'><img src='/images/header/y.svg' className='customHover cursor-pointer  w-4 md:w-7'/></a>
          </div>

        </div>



        

    </div>
  )
}

export default Header